import _ from 'lodash';
import {
    CHARITY,
    CHARITIES
} from '../actions/types';

export default function(state = {}, action) {
    switch (action.type) {
        case CHARITY: // parse a project and update state
        //     if (_.hasIn(state, action.payload.projectId)) {
            return { ...state, [action.payload[0].org]: action.payload[0] };
        //     } else {
        //         return state;
        //     }
        case CHARITIES: // parse a list of projects and update state
            return { ...state, ..._.mapKeys(action.payload, 'org') };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/charitiesReducer.js